<div class="body">

    <div class="entry" *ngFor="let mail of formGroup.controls['defaultMails'].value">

        <div class="row">

            <app-select-e-mail-address [ngModel]="currentEMailReceiverControl.value" (ngModelChange)="setEMailAddresses(mail, $event)"></app-select-e-mail-address>

            <app-select-default-notification [ngModel]="mail.maildefaultnotification" (ngModelChange)="setEMailNotification(mail, $event)"></app-select-default-notification>

        </div>

        <ng-container *ngFor="let receiver of mail.mailreceiver">

            <div class="receiver-preview">
                
                <div class="control-wrapper">
                    <button mat-icon-button class="remove-control" color="warn" (click)="removeEMailAddress(mail, receiver)">
                        <mat-icon>delete_forever</mat-icon>
                    </button>
                </div>
                <div class="address">{{receiver}}</div>

            </div>

        </ng-container>

        <div class="footer">

            <button mat-raised-button color="warn" (click)="deleteEMail(mail)">
                Löschen
            </button>

        </div>

    </div>
    
</div>
